import { StepEvent } from "./events";
import { Step } from "./step";

export class Wizard {
    #steps : Step[];
    #activeStepIndex = 0;

    get steps() {
        return this.#steps.filter(step => step.isEnabled ?? true);
    }

    get activeStep() {
        return this.steps[this.#activeStepIndex];
    }

    get activeStepNumber() {
        return this.#activeStepIndex + 1;
    }

    get isComplete() {
        return this.steps.every(step => step.isTouched && step.isValid);
    }

    get hasPrevious() {
        return this.#activeStepIndex > 0;
    }

    get hasNext() {
        return this.#activeStepIndex + 1 < this.steps.length;
    }

    constructor(steps : Step[]) {
        this.#steps = steps;
    }

    previous() {
        if (this.hasPrevious) {
            this.#activeStepIndex--;
        }
    }

    next() {
        const finishingResult = this.activeStep.handle(StepEvent.Finishing);

        if (finishingResult !== false && this.hasNext) {
            this.#activeStepIndex++;
        }
    }
}
